<div class="outer-container">
    <!-- <div class="division"> -->
    <div>





        <!-- <div class="column2"> -->


        <app-drop-down-meritor *ngIf="formDetails" currentPage="mertor" [formDetails]="formDetails"
            [selectedValues]="selectedValues" (onSelectFilter)="searchSalesData($event)" (onReset)="resetFilter($event)"
            [reset]="reset"></app-drop-down-meritor>




        <!-- <div class="filter">
                        <span (click)="resetFilter()" class="reset"><img src="../../../../../assets/images/clear.png" />&nbsp;
                            RESET</span>
                        <button fxFlexAlign="top right" mat-icon-button [matMenuTriggerFor]="filterMenu">
                            Top 5
                        </button>
        
                        <mat-menu #filterMenu="matMenu">
                            <div class="pad-menu" fxLayout="column">
                                <mat-radio-group fxLayout="column" class="bottom-separator" [(ngModel)]="radio">
                                    <mat-radio-button class="rdbtn" value="engine_model"
                                        (change)="searchDimension($event.value)">Engine</mat-radio-button>
                                    <mat-radio-button class="rdbtn" value="certification"
                                        (change)="searchDimension($event.value)">Certification</mat-radio-button>
                                    <mat-radio-button class="rdbtn" value="ecc"
                                        (change)="searchDimension($event.value)">ECC</mat-radio-button>
                                    <mat-radio-button class="rdbtn" value="parts"
                                        (change)="searchDimension($event.value)">Parts</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </mat-menu>
                    </div> -->


        <!-- </div> -->







        <!-- <app-drop-down-meritor *ngIf="formDetails" currentPage="mertor" [formDetails]="formDetails"
                [selectedValues]="selectedValues" (onSelectFilter)="searchSalesData($event)"
                [reset]="reset"></app-drop-down-meritor> -->





        <div class="column1">



            <div class="card-container-top">

                <!-- <div class="impact-card">
                    <div class="header">TARGET IMPACT</div>
                    <div class="content">
                        <div class="column dollar">
                            ${{ algorithm.target_impact | numberSuffix : 1 }}
                        </div>
                        <div class="column percent">
                            {{ algorithm.target_impact_per | percent }}
                        </div>
                    </div>
                </div> -->

                <!-- <div class="impact-card">
                    <div class="header">TARGET IMPACT PERCENTAGE</div>
                    <div class="content">
                        <div class="column dollar">
                            ${{ algorithm.target_impact | numberSuffix : 1 }}
                        </div>
                        <div class="column percent">
                            {{ algorithm.target_impact_per | percent }}
                        </div>
                    </div>
                </div> -->

                <div class="impact-card">
                    <div class="header">ACTUAL IMPACT</div>
                    <div class="content">
                        <div class="column dollar">
                            ${{ algorithm.actual_impact | numberSuffix : 1 }}
                        </div>
                        <!-- <div class="column percent">
                            {{ algorithm.actual_impact_per | percent }}
                        </div> -->
                    </div>
                </div>

                <div class="impact-card">
                    <div class="header">ACTUAL IMPACT PERCENTAGE</div>
                    <div class="content">
                        <!-- <div class="column dollar">
                            ${{ algorithm.actual_impact | numberSuffix : 1 }}
                        </div> -->
                        <div class="column percent">
                            {{ algorithm.actual_impact_per | percent }}
                        </div>
                    </div>
                </div>



                <!-- <div class="card">
                    <div class="content">
                        <span class="text">
                            Sales growth was {{ algorithm.x | percent }} with a margin growth
                            of {{ algorithm.y | numberSuffix : 1 }} p.p</span>
                        <p>SALES IMPACT</p>
                    </div>
                </div> -->

                <!-- <div class="card">
                    <div class="content">
                        <span class="text">
                            Price Impact is ${{ algorithm.a | numberSuffix : 1 }} with an
                            impact percentage of {{ algorithm.b | percent }}</span>
                        <p>PRICE IMPACT</p>
                    </div>
                </div> -->


                <!-- <div class="card">
                    <div class="content">
                        <span class="text">
                            Volume Impact is ${{ algorithm.h | numberSuffix : 1 }} with an
                            impact percentage of {{ algorithm.j | percent }}</span>
                        <p>VOLUME IMPACT</p>
                    </div>
                </div> -->

            </div>

              <div class="card-container-bottom">
                <div class="impact-card">
                    <div class="header-bottom">SALES GROWTH IMPACT</div>
                    <div class="content">
                        <div class="column dollar">
                            {{ algorithm.x | percent }}
                            <span class="subtext">Sales</span>
                        </div>

                        <div class="column percent">
                            {{ algorithm.y | numberSuffix : 1 }}P. P
                            <span class="subtext">Margin</span>
                        </div>
                    </div>
                </div>

                <div class="impact-card">
                    <div class="header-bottom">PRICE IMPACT</div>
                    <div class="content">
                        <div class="column dollar">
                            ${{ algorithm.a | numberSuffix: 1 }}
                        </div>

                        <div class="column percent">
                            {{ algorithm.b | percent }}
                        </div>
                    </div>
                </div>

                <div class="impact-card">
                    <div class="header-bottom">VOLUME IMPACT</div>
                    <div class="content">
                        <div class="column dollar">
                            ${{ algorithm.h | numberSuffix: 1 }}
                        </div>

                        <div class="column percent">
                            {{ algorithm.j | percent }}
                        </div>
                    </div>
                </div>

            </div>


            <!-- <div class="filter">
                <span (click)="resetFilter($event)" class="reset"><img
                        src="../../../../../assets/images/clear.png" />&nbsp;
                    RESET</span>
                <button class="top5button" fxFlexAlign="top right" mat-raised-button [matMenuTriggerFor]="filterMenu">
                    Top 5
                </button>

                <mat-menu #filterMenu="matMenu">
                    <div class="pad-menu" fxLayout="row">
                        <mat-radio-group fxLayout="column" class="bottom-separator" [(ngModel)]="radio">
                            <mat-radio-button class="rdbtn" value="engine_model"
                                (change)="searchDimension($event.value)">Engine</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="certification"
                                (change)="searchDimension($event.value)">Certification</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="ecc"
                                (change)="searchDimension($event.value)">ECC</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="parts"
                                (change)="searchDimension($event.value)">Parts</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </mat-menu>
            </div> -->










            <!-- <div class="note-container">
                <div class="card">
                    <div class="content">
                        <span class="text">
                            Sales growth was {{ algorithm.x | percent }} with a margin growth
                            of {{ algorithm.y | numberSuffix : 1 }} p.p</span>
                        <p>SALES IMPACT</p>
                    </div>
                </div>
                <div class="card">
                    <div class="content">
                        <span class="text">
                            Price Impact is ${{ algorithm.a | numberSuffix : 1 }} with an
                            impact percentage of {{ algorithm.b | percent }}</span>
                        <p>PRICE IMPACT</p>
                    </div>
                </div>
                <div class="card">
                    <div class="content">
                        <span class="text">
                            Volume Impact is ${{ algorithm.h | numberSuffix : 1 }} with an
                            impact percentage of {{ algorithm.j | percent }}</span>
                        <p>VOLUME IMPACT</p>
                    </div>
                </div>
            </div> -->

            <div class="card-container-lables margin-top">

                <div>
                <!-- this is old colour change button -->
                    <!-- <button class="{{ selectedDi === 'All' ? 'btnClr' : 'btn' }}" (click)="byRegion()">
                        Sales by Region
                    </button> -->


                    <!-- this is new colour change button -->
                    <!-- <button (click)="byCountry()" [class.btn-clicked]="activeButton === 'byRegion'" [class.btn-unclicked]="activeButton === 'top5'"
                        (click)="setActiveButton('byRegion')">
                        Sales by Region
                    </button> -->


                    <button  mat-raised-button  
                    (click)="byDw1Digit()" 
                    [ngClass]="byDw1DigitChart ? 'dark' : 'dim'" >
                    Sales by DW-1-Digit Att</button>


                     <button mat-raised-button style="margin-left: 5px;"
                     (click)="byCountry()"
                     [ngClass]="byCountryChart ? 'dark' : 'dim'" >
                        Sales by Country
                    </button>

                    

                    

                    <!-- <button  mat-raised-button style="margin-left: 5px;" 
                    (click)="byDw3Digit()">Sales by DW-3-Digit Att</button> -->

                    <!-- <button class="lable-button" (click)="byRegion()">
                    Sales by Product Group
                </button> -->

                <!-- this is old colour change button -->
                    <!-- <button class="{{ selectedDi === '!All' ? 'btnClr' : 'btn' }} top5button"
                        [matMenuTriggerFor]="filterMenu">Top
                        5</button> -->


                        <!-- this is new colour change button -->
                <!-- <button class="top5button"
                        [matMenuTriggerFor]="filterMenu"
                        [class.btn-clicked]="activeButton === 'top5'"
                        [class.btn-unclicked]="activeButton === 'byRegion'"
                        [matMenuTriggerFor]="filterMenu"
                        (click)="setActiveButton('top5')">
                        Top 5</button> -->

                        <button mat-raised-button style="margin-left: 5px;"
                        [matMenuTriggerFor]="filterMenu"
                        (click)="top5ButtonClicks()"
                        >
                        Top 5</button>


                </div>

                <!-- <button class="{{ selectedBtn === 'sales' ? 'btnClr' : 'btn' }}" type="submit" value="sales"
                    (click)="salesButton()">
                    Sales Realization
                </button> -->
                <button class="lable-button">
                    Sales Realization
                </button>
            </div>

            <!-- <button mat-button fxFlexAlign="top right" mat-icon-button [matMenuTriggerFor]="filterMenu">
    Top 5
</button> -->

            <mat-menu #filterMenu="matMenu">
                <div class="pad-menu" fxLayout="row">
                    <mat-radio-group fxLayout="column" class="bottom-separator" [(ngModel)]="radio">
                        <mat-radio-button class="rdbtn" value="ecc_major"
                            (change)="searchDimension($event.value)">DW-1-Digit Att</mat-radio-button>
                        <mat-radio-button class="rdbtn" value="certification"
                            (change)="searchDimension($event.value)">Channel Code</mat-radio-button>
                        <mat-radio-button class="rdbtn" value="ecc"
                            (change)="searchDimension($event.value)">DW-3-Digit Att</mat-radio-button>
                        <mat-radio-button class="rdbtn" value="part_number"
                            (change)="searchDimension($event.value)">Parts</mat-radio-button>
                    </mat-radio-group>
                </div>
            </mat-menu>

            <div class="chart-box margin-top">
                <div>
                    <app-sales-by-region-meritor-chart *ngIf="byCountryChart
              && selectedDi == 'All' && salesByRegion.length !== 0 && top5Loaded
            " [salesByRegion]="salesByRegion" (onLegendClick)="legendClickByRegion($event)"
                        legend="country"></app-sales-by-region-meritor-chart>

                        <app-sales-by-region-meritor-chart *ngIf="byDw1DigitChart
              && selectedDi == 'All' && salesByDw1Digit.length !== 0 && top5Loaded
            " [salesByRegion]="salesByDw1Digit" (onLegendClick)="legendClickByDw1Digit($event)"
                        legend="ecc_major"></app-sales-by-region-meritor-chart>

                        <!-- <app-sales-by-region-meritor-chart *ngIf="byDw3DigitChart
              && selectedDi == 'All' && salesByDw3Digit.length !== 0 && top5Loaded
            " [salesByRegion]="salesByDw3Digit" (onLegendClick)="legendClickByDw3Digit($event)"
                        legend="ecc"></app-sales-by-region-meritor-chart> -->




                    <app-top5-meritor-chart *ngIf="selectedDi !== 'All' && top5.length !== 0 && top5Loaded"
                        [top5]="top5" [button]="selectedDi"></app-top5-meritor-chart>



                    <!-- <carousel [interval]="0">
                        <slide>
                            <div>
                            <app-top5-meritor-chart *ngIf="selectedDi !== 'All' && chartDataEcc && top5Loaded"
                                [top5]="chartDataEcc" [button]="selectedDi"></app-top5-meritor-chart>
                                </div>
                        </slide>
                        <slide>
                            <div>
                            <app-top5-meritor-chart *ngIf="selectedDi !== 'All' && chartDataEngineModel && top5Loaded"
                                [top5]="chartDataEngineModel" [button]="selectedDi"></app-top5-meritor-chart>
                                </div>
                        </slide>
                        <slide>
                            <div>
                            <app-top5-meritor-chart *ngIf="selectedDi !== 'All' && chartDataCertification && top5Loaded"
                                [top5]="chartDataCertification" [button]="selectedDi"></app-top5-meritor-chart>
                                </div>
                        </slide>
                        <slide>
                            <div>
                            <app-top5-meritor-chart *ngIf="selectedDi !== 'All' && chartDataParts && top5Loaded"
                                [top5]="chartDataParts" [button]="selectedDi"></app-top5-meritor-chart>
                                </div>
                        </slide>
                    </carousel> -->





                </div>
                <div>

                    <app-sales-realization-meritor-chart source='nrp' *ngIf="
                  selectedBtn == 'sales' && salesReal.length !== 0 && dataLoaded
                " [salesReal]="salesReal" (chartClick)="onChartClick($event)"></app-sales-realization-meritor-chart>


                </div>
            </div>
        </div>











        <!-- <div class="column2">
            <div class="high-value-title">
                <span class="subhead">{{ title }}</span>
                <span (click)="resetFilter()" class="reset"><img src="../../../../../assets/images/clear.png" />&nbsp;
                    RESET</span>
            </div>

            <div class="filter">
                <span class="filter">
                    <mat-icon style="color: black">filter_alt_outline </mat-icon>
                    Filter</span>
                <span>|</span>
                <button fxFlexAlign="top right" mat-icon-button [matMenuTriggerFor]="filterMenu">
                    Top 5
                </button>

                <mat-menu #filterMenu="matMenu">
                    <div class="pad-menu" fxLayout="column">
                        <mat-radio-group fxLayout="column" class="bottom-separator" [(ngModel)]="radio">
                            <mat-radio-button class="rdbtn" value="engine_model"
                                (change)="searchDimension($event.value)">Engine</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="certification"
                                (change)="searchDimension($event.value)">Certification</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="ecc"
                                (change)="searchDimension($event.value)">ECC</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="parts"
                                (change)="searchDimension($event.value)">Parts</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </mat-menu>
            </div>

            <app-nrp-selection *ngIf="formDetails" currentPage="mertor" [formDetails]="formDetails"
                [selectedValues]="selectedValues" (onSelectFilter)="searchSalesData($event)"
                [reset]="reset"></app-nrp-selection>
        </div> -->
    </div>
</div>